/* src/app/modules/shared/components/tippy-tooltip/tippy-tooltip.component.scss */
::ng-deep .tippy-box {
  background: var(--base-3, #fff);
  color: var(--color-text-strong, rgba(0, 0, 0, 0.9));
  font-size: var(--text-title-1-font-size, 14px);
  line-height: var(--text-title-1-line-height, 20px);
  border-radius: 2px;
  box-shadow: var(--shadow-overlay, 0px 2px 4px 0px rgba(0, 0, 0, 0.04), 0px 2px 8px 0px rgba(0, 0, 0, 0.1));
  padding-bottom: 1rem;
  width: 95%;
}
::ng-deep .tippy-box h3 {
  margin-left: 1.4rem;
  padding-top: 1.4rem;
}
/*# sourceMappingURL=tippy-tooltip.component.css.map */
